import { useAuth } from '@/contexts/AuthContext'
import { accountApiService, accountQueries } from '@/services/accountApi'
import type { CallHistoryItem } from '@/types/account'
import { useInfiniteScrollQuery } from './useInfiniteScrollQuery'

export const CALL_HISTORY_PAGE_SIZE = 30

interface UseInfiniteCallHistoryQueryOptions {
  query?: string
}

export const useInfiniteCallHistoryQuery = ({ query }: UseInfiniteCallHistoryQueryOptions = {}) => {
  const { isAuthenticated } = useAuth()

  const { items: calls, ...rest } = useInfiniteScrollQuery<
    Awaited<ReturnType<typeof accountApiService.getCallHistory>>,
    CallHistoryItem
  >({
    queryKey: [...accountQueries.callHistoryInfiniteBase, query ?? null],
    queryFn: (page, pageSize) => accountApiService.getCallHistory(page, pageSize, query),
    transform: (data) => ({
      items: data.calls,
      totalItems: data.totalItems,
      totalPages: data.totalPages,
      page: data.page,
    }),
    pageSize: CALL_HISTORY_PAGE_SIZE,
    enabled: isAuthenticated,
  })

  return { calls, ...rest }
}
